<div class="input-group"  style="white-space: nowrap;">
  <input [formControl]="searchField" type="text" class="form-control" placeholder="{{'RI_FM_LBL_SEARCH_FOR' | translate}}">
  <span class="input-group-append">
      <button (click)="searchField.reset('')" class="btn btn-secondary" type="button">
          <i class="fa fa-times"></i>
      </button>
  </span>
</div>
